import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { inject } from 'mobx-react';

import { Select } from 'core/components';
import LabelOptionRenderer from 'app/components/labels/LabelOptionRenderer';
import LabelList from 'app/components/labels/LabelList';
import LabelValueTagRenderer from 'app/components/labels/LabelValueTagRenderer';

@inject('$auth', '$labels')
@withRouter
class LabelSelectorList extends Component {
  /*
    This is a simpler form of LabelSelector that does NOT depend on forms, etc.
    It also puts the add label capability in a renderAsButton form of select
    That button can be configured with normal Select props via restSelectProps

  */

  render() {
    const {
      $labels,
      handleLabelSelect,
      onRemove = () => {},
      selectedList,
      options,
      labelOptions,
      maxLabelsToShow = 4,
      buttonLabel = 'Add Label',
      wrapLabels,
      ...restSelectProps
    } = this.props;

    const selectOptions = options ?? $labels.options;

    const resolvedLabels = labelOptions ?? $labels.getLabelOptionsFromIds(selectedList);

    const addButtonElement = (
      <Select
        optionRenderer={LabelOptionRenderer}
        valueTagRenderer={LabelValueTagRenderer}
        options={selectOptions}
        multi
        toggle
        renderAsButton
        hideSelected
        showFilter
        buttonStyle={{ text: buttonLabel, rightIcon: 'chevron-down' }}
        small
        menuWidth={null}
        values={selectedList}
        onChange={handleLabelSelect}
        {...restSelectProps}
      />
    );

    return (
      <>
        <LabelList
          display="inline-block"
          wrapperAlignItems="center"
          maxLabelsToShow={maxLabelsToShow}
          wrapLabels={wrapLabels}
          labels={resolvedLabels}
          onRemove={onRemove}
          renderEmpty
          endElement={addButtonElement}
          data-testid="labelList"
        />
      </>
    );
  }
}

export default LabelSelectorList;
